import Store from '../utils/Store';
import globalMessages from '../constants/globalMessages';

const initialState = {
  session: {
    authToken: '',
    unifiedAuthToken: '',
    idToken: '',
    accessToken: '',
    expires: 0,
    authenticated: false,
  },
  portalExperimentAssignments: {},
  locale: typeof navigator !== 'undefined'
    ? navigator.language?.replace(/-.*$/g, '') || 'en'
    : 'en',
  redirectUrl: '',
  campaignHomeIntent: {
    debtId: null,
    cta: null,
  },
  postLoginExperience: {
    utmContent: null,
  },
  referenceNumbers: [],
  selectedReferenceNumber: null,
  account: {
    // TODO fix up this initial state, it's wrong
    // (check API reference)
    referenceNumber: null,
    verified: false,
    disclosures: {
      solDisclosureID: 0,
      currentCreditorName: '',
    },
  },
  activePaymentPlans: null,
  paymentHistory: null,
  promoCode: null,
  documents: null,
  paymentPlan: {
    planType: null,
    numPayments: 0,
    totalPaymentAmount: null,
    standardPaymentAmount: null,
    lastPaymentAmount: null,
    paymentFrequency: null,
    paymentBiweeklyCadence: null,
    paymentDayOfMonth: null,
    paymentDayOfWeek: null,
    paymentStartDate: null,
    paymentStartDateLimit: 14,
    paymentSchedule: [],
    paymentMatchOffer: null,
    failedPaymentDismissalId: null,
    replaceExistingActivePlan: false,
    failedPaymentUpdateIdempotencyKey: null,
    requiresPaymentFrequencySelection: false,
    partialSelectorVariant: null,
    partialSelectorReferenceNumber: null,
  },
  defaultSpecialPlan: {
    planType: null,
    numPayments: 0,
    totalPaymentAmount: null,
    standardPaymentAmount: null,
    lastPaymentAmount: null,
    paymentFrequency: null,
    paymentBiweeklyCadence: null,
    paymentDayOfMonth: null,
    paymentDayOfWeek: null,
    paymentStartDate: null,
    paymentStartDateLimit: 14,
    paymentSchedule: [],
  },
  settlementOffers: {
    currentBalance: null,
    offerAmount: null,
    plans: [],
  },
  paymentMethod: {
    consumerName: null,
    paymentSource: null,
    type: null,
    cardType: null,
    routingNumber: null,
    pnRef: null,
    result: null,
    last4: null,
    token: null,
    date: null,
    referenceNumber: null,
  },
  shortLink: {
    referenceNumber: null,
    ref: null,
    shortUrl: null,
    fullUrlPath: null,
    verified: null,
    preferredLanguage: null,
    disclosureData: {
      currentCreditorName: null,
      isPastSol: null,
      isCreditReportingEnabled: null,
    },
  },
  menuToggled: false,
  accountsInformation: [],
  negotiatedPlan: {
    referenceNumber: null,
    currentBalance: null,
    offerAmount: null,
    planType: null,
    proposedAmountApproved: true,
    planOptions: {},
  },
  selectedPlanType: '',
  comesFromSplashPage: false,
  comesFromFrictionlessPage: false,
  selectedStep: '',
  reference: '',
  accountSwitched: false,
  theme: {},
};

// Keep authentication, account identifiers, identity/payment details, and
// navigation state in memory only. The small persisted subset contains no PII
// or bearer credentials and is safe to restore after a refresh.
const persistPortalPreferences = (state = {}) => ({
  locale: state.locale,
  portalExperimentAssignments: state.portalExperimentAssignments || {},
  postLoginExperience: state.postLoginExperience || { utmContent: null },
  theme: state.theme || {},
});

const isMockApi = process.env.MOCK_API === 'true';
const persistPortalState = (state = {}, mockApi = isMockApi) =>
  mockApi ? state : persistPortalPreferences(state);

const hydratePortalState = (
  state = {},
  mockApi = isMockApi
) => persistPortalState(state, mockApi);

// A supported ?lang= overrides the browser language and any saved preference, as
// LanguageSelect applies it. Resolving it here rather than in that component's effect
// means the very first render (including the first-load screen's phrases) is already in
// the requested language.
const getRequestedLocale = (search = typeof window !== 'undefined' ? window.location?.search : '') => {
  const lang = new URLSearchParams(search || '').get('lang');
  return lang && Object.prototype.hasOwnProperty.call(globalMessages, lang) ? lang : null;
};

const withRequestedLocale = (state = {}, requestedLocale = getRequestedLocale()) =>
  requestedLocale ? { ...state, locale: requestedLocale } : state;

const store = new Store({
  initialState,
  storageKey: 'soc-portal',
  persist: persistPortalState,
  hydrate: (state) => withRequestedLocale(hydratePortalState(state)),
});

export default store;
export {
  getRequestedLocale,
  hydratePortalState,
  initialState,
  persistPortalPreferences,
  persistPortalState,
  withRequestedLocale,
};
